/* file description */
import * as React from 'react';
import { Layout, Typography } from 'antd';
import styles from '../index.module.less';
import { Tabs } from 'antd-mobile';
import useMetaStore from '@/store/useMetaStore';

const { Title } = Typography;

export const PageLayout = (props) => {
  const { isMobile } = useMetaStore();
  if (isMobile) {
    const filterChildren = props.children.filter((item: any) => {
      return ![undefined, false, null].includes(item);
    });
    if (filterChildren.length === 1 || !props.collapsed) {
      return (
        <div className={'CASCADECENTRE MOBILECENTRE '}>
          <div className={styles.mobileTitle}>
            <Title level={2}>{filterChildren[0].props?.slotName}</Title>
          </div>
          {filterChildren}
          {/* <div style={{ padding: '0px 16px' }}> */}
          {/* </div> */}
        </div>
      );
    }
    return (
      <Tabs className={'CASCADECENTRE MOBILECENTRE '}>
        {
          filterChildren.map((ele, index) => {
            return (<Tabs.Tab title={ele.props?.slotName} key={ele.props?.slotName + index} forceRender>{ele}</Tabs.Tab>);
          })
        }
      </Tabs>);
  }

  return (
    <Layout className={'CASCADECENTRE '} style={{ backgroundColor: '#fff' }}>
      {props.children}
    </Layout>
  );
};
